import React, { useEffect } from 'react';
import { Avatar, Pagination, Table } from 'antd';
import type { ColumnsType } from 'antd/es/table';



const LeaveReportTable = ({ leavePolicyReports, isSubmit, loader, currentPage, pageSize, count, onShowSizeChange, setCurrentPage, getLeaveReport, handlePaginationChange, hasFilters }: any) => {
  const getReportLeaveType = (name: string): string => {
    const words = name?.split(' ');
    if (words?.length >= 2) {
      const firstNameInitial = words[0][0].toUpperCase();
      const lastNameInitial = words[words?.length - 1][0].toUpperCase();
      return `${firstNameInitial}${lastNameInitial}`;
    } else if (words?.length === 1) {
      return words[0][0].toUpperCase();
    } else {
      return '';
    }
  };

  useEffect(() => {
    const tags = document.getElementsByClassName('ant-table-content');
    if (tags.length > 1) {
      tags[1].scrollTop = 0;
    }
    if (!hasFilters && currentPage !== 0) {
      setCurrentPage(currentPage - 1);
    } else {
      setCurrentPage(1);
    }
  }, [hasFilters]);

  const formatLeaveDurationReport = (leaveDurationHours: number): string => {
    const hourPart = Math.floor(leaveDurationHours);
    const minutePart = Math.round((leaveDurationHours - hourPart) * 60);

    const adjustedHours = minutePart === 60 ? hourPart + 1 : hourPart;
    const adjustedMinutes = minutePart === 60 ? 0 : minutePart;

    return `${adjustedHours}h ${adjustedMinutes}m`;
  };



  const columns: ColumnsType<any> = [
    {
      title: 'Employee Name',
      dataIndex: 'employeeName',
      width: "12%",
    },
    {
      title: 'Types',
      dataIndex: 'policyType',
      width: "12%",
      render: (text) => (
        <div className='flex items-center leave-type'>   <Avatar.Group
          maxCount={3}
          maxPopoverTrigger="click"
          size="large"
          maxStyle={{ color: '#f56a00', backgroundColor: '#fde3cf', cursor: 'pointer' }}
        >
          <Avatar className={"leave-type-" + text} >{getReportLeaveType(text)}</Avatar>
        </Avatar.Group>
          <p className='ml-2'>{text}</p>
        </div>
      ),
    },
    {
      title: 'From ',
      dataIndex: 'formattedFromDate',
      width: "9%",

    },
    {
      title: 'To ',
      dataIndex: 'formattedToDate',
      width: "9%",
    },
    {
      title: 'Duration ',
      dataIndex: 'duration',
      width: "9%",
      render: (text, record) => {

        return (
          <div className='flex space-x-1 ml-5'>
            <p >            {["Permission", "On duty"].includes(record?.policyType)
              ? formatLeaveDurationReport(text)
              : `${text}d`}</p>

            {record.lopCount > 0 && (
              <p className='text-red-400 text-[13px]'>(LOP-<span>{record.lopCount}</span>)</p>
            )}
          </div>
        );
      },
    },
    {
      title: 'Status ',
      dataIndex: 'status',
      width: "9%",
      render: (text: string) => (
        <div className='ml-2'>
          <p className="capitalize ">{text}</p>
        </div>
      ),

    },
    {
      title: 'Reason ',
      dataIndex: 'reason',
      width: "14%",
    },]


  return (
    <div className='leave-report leave-table head relative'>
      <Table columns={columns} dataSource={leavePolicyReports} loading={loader} pagination={false} />
      <div className='pagination'>
        <Pagination
          className='float-right flex flex-row p-6'
          showSizeChanger
          onShowSizeChange={onShowSizeChange}
          current={currentPage === 0 ? 1 : currentPage}
          total={count}
          pageSize={pageSize}
          onChange={handlePaginationChange}
        />
      </div>
    </div>
  )
}

export default LeaveReportTable